export default {"src":"/_next/static/media/atm.1170c5fd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};